import { render, staticRenderFns } from "./PixBoleto.vue?vue&type=template&id=7c157b45&scoped=true&"
import script from "./PixBoleto.vue?vue&type=script&lang=js&"
export * from "./PixBoleto.vue?vue&type=script&lang=js&"
import style0 from "./PixBoleto.vue?vue&type=style&index=0&id=7c157b45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c157b45",
  null
  
)

export default component.exports